export const featuredUgcVideosComponent = {
  key: 'featuredUgcVideosComponent',
  name: 'Featured Ugc Videos Component',
  siteIdentifier: 'global',

  openVideoAriaLabel: 'Open {headline} Video',
  videoThumbnailAlt: 'Video Thumbnail',
};
